export default ".active-orange-button{color:#ff5722;border-color:#ff5722}.dx-editor-filled{background-color:rgba(0,0,0,0);height:35px;margin-right:20px}";